import { render, staticRenderFns } from "./ConvidarPorSms.vue?vue&type=template&id=bddba802"
import script from "./ConvidarPorSms.vue?vue&type=script&lang=js"
export * from "./ConvidarPorSms.vue?vue&type=script&lang=js"
import style0 from "./ConvidarPorSms.vue?vue&type=style&index=0&id=bddba802&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports